<!-- Back button -->
<button mat-flat-button id="backButton" [routerLink]="['/hem']">
  <mat-icon>arrow_back</mat-icon> Till startsidan
</button>

<section class="order-checkout">
  <h2>{{ paymentFinished ? 'Order genomförd' : 'Hantera betalning' }}</h2>
  <h3>Order #{{ currentOrder.orderId }}</h3>

  <!-- Order object summary -->
  <div class="order-summary">
    @for (item of currentOrder.orderItems; track item) {
      <div>
        <div class="item-spec">
          @if (item.orderItemType === 'FEATURE') {
            <span class="label"><strong>{{ item.feature?.name }}</strong>
          (Tilläggstjänst)</span>
        }
        @if (item.orderItemType === 'RESOURCE') {
          <span class="label"><strong>{{ item.booking?.registrationNumber }}</strong>
          (Bokning)
        </span>
      }
      @if (item.orderItemType === 'PREPAIDTICKET') {
        <span class="label">
          <strong>{{ item.prepaidTicket?.name }}</strong> (Abonnemang)
        </span>
      }
      <span class="flex">
        <strong class="item-amt">{{ item.amount }} kr</strong>
        @if (!paymentFinished && allowPayments) {
          <button class="button slim success discount-btn"
            (click)="setDiscountItem(item)" matTooltip="Rabatt">
            <mat-icon class="icon-display">local_offer</mat-icon>
          </button>
        }
      </span>
    </div>
    @if (item.discount) {
      <div class="item-spec discount-item">
        <span>Rabatt: {{item.discountComment}}</span>
        <span class="flex">
          <p class="discount-amount">-{{item.discount}} kr</p>@if (!hideRemoveDiscount(item) && !paymentFinished && allowPayments) {
          <mat-icon
          class="remove-discount" (click)="removeDiscount(item)">clear</mat-icon>
        }
      </span>
    </div>
  }
  <!-- Discount -->
  @if (discountedItem === item && discountForm) {
    <form [formGroup]="discountForm" class="item-spec">
      <mat-form-field class="normal-input">
        <mat-label>Belopp</mat-label>
        <input matInput type="number" formControlName="discountAmount" name="discountAmount" [max]="item.amount || 0">
        <mat-error>Max rabatt {{item.amount}} kr</mat-error>
      </mat-form-field>
      <mat-form-field class="wide-input">
        <mat-label>Motivering</mat-label>
        <input matInput type="text" formControlName="discountComment" name="discountComment">
      </mat-form-field>
      <button class="button slim success discount-button" (click)="applyDiscount()" matTooltip="Applicera rabatt"
      [disabled]="!discountForm.valid">Applicera</button>
    </form>
  }
</div>
}
</div>

<!-- Order price summary -->
<div class="total-wrapper">
  <p>
    <span>Ordinarie pris: </span><span>{{ currentOrder.totalAmountWithoutDiscount }} kr</span>
  </p>
  @if (currentOrder.discount) {
    <p><span>Rabatt: </span><span>-{{currentOrder.discount}} kr</span></p>
  }
  @if (currentOrder.paidAmount) {
    <p><span>Betalat belopp:</span> <span>{{ currentOrder.paidAmount }} kr</span></p>
  }
  <p class="total-amount">
    <span>{{refund ? 'Att återbetala: ' : 'Att betala: '}}</span><span>{{ currentOrder.amountToPay }} kr</span>
  </p>
</div>

<!-- Payment options -->
@if (!paymentFinished && !zeroCheckout && !refund && allowPayments) {
  <div class="radio-buttons">
    <h4>Betalningsmetod</h4>
    <form [formGroup]="paymentMethod">
      <mat-radio-group formControlName="method" name="method">
        <mat-radio-button [value]="'Kort'">Kort</mat-radio-button>
        <mat-radio-button [value]="'Kontant'">Kontant</mat-radio-button>
        <mat-radio-button [value]="'Betala senare'">Betala senare</mat-radio-button>
        <mat-radio-button [value]="'Faktura'">Faktura</mat-radio-button>
      </mat-radio-group>
    </form>
  </div>
}

@if (paymentFinished && this.paymentMethod.controls['method'].value) {
  <div class="selected-payment-method">
    <p><strong>Vald betalningsmetod:</strong> {{this.paymentMethod.controls['method'].value}}</p>
  </div>
}

<!-- Unfinished started payments -->
@if (startedPayments?.length) {
  <app-unfinished-payments
  [startedPayments]="startedPayments"></app-unfinished-payments>
}

@if (startedPayments?.length) {
  <button class="button slim to-order-btn" (click)="goToOrder()">Gå till
  ordersidan</button>
}

<!-- Invoice information -->
@if (!paymentFinished) {
  <div class="invoice-wrapper">
    <mat-expansion-panel [expanded]="paymentMethod.controls['method'].value === 'Faktura'" hideToggle>
      <div class="invoice-form-wrapper">
        <h4>Fakturauppgifter</h4>
        @if (paymentMethod.controls['method'].value === 'Faktura') {
          <app-invoice-form-fields [value]="invoice" (saved)="onInvoiceSave($event)" (valid)="childFormValid = $event" #invoiceFields>
          </app-invoice-form-fields>
        }
      </div>
    </mat-expansion-panel>
  </div>
}

@if (invalidFormMessage) {
  <div class="invalid-form-message">
    <mat-icon>error</mat-icon> <span>{{ invalidFormMessage }}</span>
    <mat-icon>error</mat-icon>
  </div>
}

@if (paymentFinished) {
  <div class="checkout-buttons to-booking">
    @if (!containsOnlyPrepaid()) {
      <button class="button slim success" [disabled]="getBookingId() === undefined"
        (click)="goToBooking()">
        Gå till detaljsidan
      </button>
    }
    @if (containsOnlyPrepaid()) {
      <button class="button slim success" [routerLink]="['/abonnemang']">
        Gå till abonnemang
      </button>
    }
    @if (!newOrder) {
      <button [ngClass]="{'button': true, 'slim': true, 'success': true, 'loading': loading}"
        (click)="sendEmail()">
        Skicka bokningsbekräftelse
        @if (loading) {
          <mat-spinner diameter="25" color="accent"></mat-spinner>
        }
      </button>
    }
    @if (!newOrder && emailMsg) {
      <p [ngClass]="{'confirmation-msg': true, 'success': emailSent, 'failed': !emailSent}" class="confirmation-msg"
      >{{emailMsg}}</p>
    }
  </div>
}

@if (!paymentFinished && allowPayments) {
  <div class="checkout-buttons">
    @if (refund) {
      <button class="button success" (click)="handleRefund()">Hantera återbetalning</button>
    }
    @if (refund) {
      <button class="button success" (click)="payLater(currentOrder)">Betala senare</button>
    }
    @if (newOrder && !refund) {
      <button class="button slim warning" (click)="cancelOrder()">
        Makulera order
      </button>
    }
    @if (!zeroCheckout && !refund) {
<button class="button success" (click)="handlePayment()" [disabled]="
      !paymentMethod.controls['method'].value ||
      (paymentMethod.controls['method'].value === 'Faktura' && !childFormValid)
    ">
        {{
        paymentMethod.controls['method'].value === 'Faktura' ||
        paymentMethod.controls['method'].value === 'Betala senare'
        ? 'Spara'
        : 'Starta betalning'
        }}
      </button>
    }
    @if (zeroCheckout && !refund) {
      <button class="button success" [ngClass]="{'loading': loading}"
        (click)="handlePayment()">
        Slutför order
        @if (loading) {
          <mat-spinner diameter="25" color="accent"></mat-spinner>
        }
      </button>
    }
  </div>
}
</section>

<!-- Receipt -->
<iframe #iframe id="iframe" name="iframe">
</iframe>